export enum Model3dEntryStatus {
  CREATED = 'created',
  READY_FOR_UPLOAD = 'ready_for_upload',
  INPUT_UPLOADED = 'input_uploaded',

  PROCESS_STARTED = 'process_started',
  PROCESS_PREPARING = 'process_preparing',
  PROCESS_CONVERTING = 'process_converting',
  PROCESS_FINALIZING = 'process_finalizing',
  PROCESS_COMPLETED = 'process_completed',
  PROCESS_ERROR = 'process_error',
}

export enum Model3dEntryStatusCsv {
  PROCESS_STARTED = 'process_started',
  PROCESS_PREPARING = 'process_preparing',
  PROCESS_CONVERTING = 'process_converting',
  PROCESS_FINALIZING = 'process_finalizing',
  PROCESS_COMPLETED = 'process_completed',
  PROCESS_ERROR = 'process_error',
}
